// Typed access to the generated route table and URL contracts.
//
// routes.json is the parity oracle for §1.3: careero's BI importers classify events by
// string-prefix-matching these paths, so a path is a contract, not a label. Regenerate
// with `pnpm extract:routes` — never hand-edit it.
import routesJson from '../routes.json'
import urlContractsJson from '../url-contracts.json'

/** A value the upstream source computes at runtime rather than declaring literally. */
export const COMPUTED = '<computed>'

export type ParamType = 'int' | 'bool' | 'string' | 'date' | 'json' | (string & {})

export interface RouteParamSpec {
  /** ui-router param type; absent means the default (`string`). */
  type?: ParamType
  /** `params: { x: { value: … } }` — also marks the param as non-URL when absent from the path. */
  default?: string | number | boolean | null
  squash?: string | number | boolean | null
  dynamic?: boolean
  array?: boolean
}

export interface Route {
  /** ui-router state name, e.g. `chrome-extension.extension-tabs.shortlist.hunter.review`. */
  state: string
  /** Full path with every ancestor segment, e.g. `/chrome-extension/extension/shortlist/review`. */
  path: string
  /** Query params in scope, this state's and every ancestor's. */
  queryParams: string[]
  /** Every declared param, URL and non-URL alike, with its type and default. */
  params: Record<string, RouteParamSpec>
  abstract: boolean
  /** Named views, keyed `viewName@targetState`. */
  views: string[]
  templates: number
  controllers: number
  data: Record<string, string | number | boolean | null>
  resolve: string[]
  onEnter: boolean
  onExit: boolean
  /** `<file>:<line>` within the upstream subtree. */
  source: string
}

export interface RouteTable {
  meta: {
    generatedBy: string
    upstream: { repo: string; sha: string; date: string; subtree: string }
    note: string
  }
  stateCount: number
  routes: Route[]
  diagnostics: {
    unresolvedStateNames: string[]
    statesWithoutUrl: string[]
    unresolvedViewKeys: string[]
    enumMembersNeverRegistered: string[]
    duplicatePaths: Array<{ path: string; states: string[] }>
  }
}

export type UrlContractRole = 'bi-tracking' | 'oauth-redirect' | 'security'

export interface UrlContract {
  literal: string
  role: UrlContractRole
  occurrences: Array<{ file: string; line: number; role: UrlContractRole; matcher: string }>
}

export interface UrlContracts {
  meta: { generatedBy: string; upstream: { repo: string; sha: string; date: string }; sources: unknown[] }
  contractCount: number
  contracts: UrlContract[]
}

// Through `unknown`: TypeScript infers an exact literal type per JSON object (each route
// gets its own `params` shape), which does not structurally overlap the declared index
// signature. The generator is what keeps these honest — see test/generated-current.test.ts.
export const routeTable = routesJson as unknown as RouteTable
export const routes: readonly Route[] = routeTable.routes
export const urlContracts = urlContractsJson as unknown as UrlContracts

export function routeByState(state: string): Route | undefined {
  return routes.find((route) => route.state === state)
}

/** Every concrete (non-abstract) route whose path starts with `prefix`. */
export function routesUnder(prefix: string): readonly Route[] {
  return routes.filter((route) => !route.abstract && route.path.startsWith(prefix))
}
